import { ChevronRight } from 'lucide-react';
import { useState } from 'react';

export default function CustomDemoButton({ to, children, type, size }) {
  const [hovered, setHovered] = useState(false);
  const [arrows, setArrows] = useState(type === 'homePage1' ? 8 : 6);

  return (
    <a
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      className={`${size} relative inline-flex items-center justify-center px-6 py-2 text-white font-semibold rounded-md overflow-hidden transition-colors duration-300 group`}
      style={{
        background:
          'linear-gradient(200deg, #6C3BB7 0%, #A689D2 25%, #7636D9 75%)',
        backgroundBlendMode: 'overlay',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Text */}
      <span
        className={`transition-all duration-300 ${
          hovered ? 'opacity-0 translate-x-4' : 'opacity-100 translate-x-0'
        }`}
      >
        {children}
      </span>

      {/* Animated Arrows */}
      <span
        className={`absolute flex items-center gap-[2px] transition-all duration-500 ${
          hovered ? 'right-6 opacity-100' : 'right-4 opacity-0'
        }`}
      >
        {[...Array(arrows)].map((_, i) => (
          <ChevronRight
            key={i}
            className={`w-4 h-4 transition-transform duration-300 delay-[${
              i * 60
            }ms] ${hovered ? 'translate-x-0' : 'translate-x-2'}`}
          />
        ))}
      </span>
    </a>
  );
}
